<template>
  <div class="container" style="position: sticky; height: calc(100vh - 90px); top: 90px; overflow-y: scroll">
    <b-row v-if="(type3DId != null && (anonym || kunde))">
      <h4 class="float-left" style="padding-left: 15px; padding-top: 39px">
        {{ $t('overview.heading') }}</h4>
    </b-row>
    <b-row v-if="(type3DId != null && (anonym || kunde))">
      <b-col>
        <ProductModel class="border rounded-lg" :id="type3DId" :isObj="isObj" :type="typenSchluessel"/>
      </b-col>
    </b-row>
    <b-row >
      <b-col style="padding-top: 30px">
        <Hinweistexte :konfig-model="konfigModel"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Hinweistexte from "@/components/config-page/utils/Hinweistexte";
import ProductModel from "@/components/config-page/utils/ProductModel";
import isEmpty from "@/mixins/isempty";

export default {
  name: "Overview",
  mixins: [isEmpty],
  components: {Hinweistexte, ProductModel},
  props: ['konfigModel'],
  computed: {
    type3DId: function() {
      return this.konfigModel.type3DId;
    },
    isObj: function () {
      return this.konfigModel.isObj;
    },
    typenSchluessel() {
      return this.konfigModel.typenSchluessel;
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
    kunde: function() {
      return this.$store.getters.getUserData.kunde;
    }
  }
}
</script>

<style scoped>

</style>